<template>
  <div>
    <div>
        <div style="border: 1px solid #cccccc">
          <!-- //搜索框 -->
          <el-amap-search-box
            ref="searchBox"
            :search-option="searchOption"
            :on-search-result="onSearchResult"
          />
          <!-- 地图 -->
          <el-amap
            class="amap-box"
            :zoom="amap.zoom"
            :center="amap.center"
            :plugin="amap.plugin"
            :events="amap.events"
          >
            <!-- 当前位置图标 -->
            <el-amap-marker
              v-for="(marker, index) in amap.markers"
              :key="'marker' + index"
              :position="marker.position"
            />
            <!-- 位置名称显示 -->
            <el-amap-text
              v-for="(marker, index) in amap.markers"
              :key="'text' + index"
              :text="marker.text"
              :offset="marker.offset"
              :position="marker.position"
            />
          </el-amap>
        </div>
    </div>
  </div>
</template>
<script>
//初始数据
function getFormData() {
  return {
    lat: "39.909186",
    lon: "116.39746",
    orgAddr: "天安门",
    province: "",
    city: "",
    district: "",
  };
}

export default {
  name: "GeoMap",
  data() {
    const vm = this;
    return {
      // form对象
      dataForm: getFormData(),
      // 地图搜索对象
      searchOption: {
        city: "",
        citylimit: true,
      },
      lng: 0,
      lat: 0,
      // 地图对象
      amap: {
        zoom: 16,
        center: [],
        events: {
          // 点击获取地址的数据
          click(e) {
            const {lng, lat} = e.lnglat;
            vm.dataForm.lon = lng;
            vm.dataForm.lat = lat;
            // 这里通过高德 SDK 完成。
            var geocoder = new AMap.Geocoder({
              radius: 100,
              extensions: "all",
            });
            geocoder.getAddress([lng, lat], function (status, result) {
              if (status === "complete" && result.info === "OK") {
                if (result && result.regeocode) {
                  let district = result.regeocode.addressComponent.district || '';
                  let address = result.regeocode.formattedAddress;
                  let index = 0;

                  // 计算地址索引（去除省市区信息）
                  if (district) {
                    index = address.indexOf(district) + district.length;
                  }

                  // 点击地图选点后，总是使用逆地理编码获取的新地址
                  vm.dataForm.orgAddr = address.substring(index, address.length);

                  vm.dataForm.province = result.regeocode.addressComponent.province;
                  vm.dataForm.city = result.regeocode.addressComponent.city;
                  vm.dataForm.district = result.regeocode.addressComponent.district;
                  vm.dataForm.lat = lat ? lat.toString() : "";
                  vm.dataForm.lon = lng ? lng.toString() : "";
                  vm.amap.markers = [];

                  // 显示地址文本
                  const displayAddress = address.substring(index, address.length);
                  const obj = {
                    position: [lng, lat],
                    text: displayAddress,
                    offset: [0, 30],
                  };
                  vm.amap.markers.push(obj);
                  vm.sure();
                }
              }
            });
            vm.$nextTick();
          },
        },

        plugin: [
          {
            // 定位
            pName: "Geolocation",
            events: {
              init(o) {
                // o是高德地图定位插件实例
                o.getCurrentPosition((status, result) => {
                  console.log("定位：", result);
                  if (result && result.position) {
                    // 设置经度
                    vm.lng = result.position.lng;
                    // 设置维度
                    vm.lat = result.position.lat;
                    // 设置坐标
                    vm.amap.center = [vm.lng, vm.lat];
                    let op = {
                      position: [vm.lng, vm.lat],
                      text: result.formattedAddress,
                      offset: [0, 30],
                    };
                    vm.amap.markers.push(op);
                    // 页面渲染好后
                    vm.$nextTick();
                  }
                });
              },
            },
          },
        ],
        //
        markers: [],
      },
    };
  },
  created() {
    this.initCenter();
  },
  methods: {
    initCenter() {
      this.amap.center = [116.319802, 39.98294]
    },
    initMarker(lng, lat, city, orgAddr) {
      const obj = {
        position: [lng, lat],
        text: orgAddr,
        offset: [0, 30],
      };
      const vm = this;
      if (null == orgAddr || orgAddr === '') {
        vm.amap.markers = []
      } else {
        vm.amap.markers = []
        vm.amap.markers.push(obj);
      }
      if (null == lng) {
        vm.initCenter()
      } else {
        vm.amap.center = [lng, lat]
      }
      vm.dataForm.city = city
      vm.dataForm.orgAddr = orgAddr
      vm.initSearchValue(orgAddr)
    },

    initSearchValue(address) {
      const vm = this;
      if (null != vm.dataForm.city || '' !== vm.dataForm.city) {
        vm.searchOption.city = vm.dataForm.city
        vm.searchOption.citylimit = true
      } else {
        vm.searchOption.city = ''
        vm.searchOption.citylimit = false
      }
      // 使用 $nextTick 确保 DOM 更新后再设置搜索框的值
      vm.$nextTick(() => {
        if (vm.$refs.searchBox) {
          // 尝试通过组件属性设置
          if (vm.$refs.searchBox.keyword !== undefined) {
            vm.$refs.searchBox.keyword = address || '';
          }
          // 同时直接操作 DOM 输入框，确保值被更新
          const searchInput = document.querySelector(".el-vue-search-box-container input");
          if (searchInput) {
            searchInput.value = address || '';
            // 触发 input 事件，确保组件感知到值的变化
            /*const event = new Event('input', { bubbles: true });
            searchInput.dispatchEvent(event);*/
          }
        }
      });
      console.log("搜索框", this.$refs.searchBox)
    },
    // 地图搜索回调
    onSearchResult(pois) {
      const vm = this;
      vm.amap.markers = [];
      let latSum = 0;
      let lngSum = 0;
      console.log("地图回调", pois);
      if (pois.length > 0) {
        pois.forEach((poi, index) => {
          const {lng, lat} = poi;
          if (index === 0) {
            lngSum = lng;
            latSum = lat;
            let obj = {};

            if (poi.address.indexOf(poi.name) > -1) {
              obj = {
                position: [poi.lng, poi.lat],
                text: poi.address,
                offset: [0, 30],
              };
            } else {
              obj = {
                position: [poi.lng, poi.lat],
                text: poi.address + poi.name,
                offset: [0, 30],
              };
            }
            let keywords = vm.$refs.searchBox.keyword
            if (null == keywords || '' === keywords) {
              vm.dataForm.orgAddr = poi.address + poi.name;
            } else {
              obj.text = keywords
              vm.dataForm.orgAddr = keywords
            }
            vm.amap.markers.push(obj);
            console.log("地图搜索回调", poi);

            vm.dataForm.lat = poi.lat ? poi.lat.toString() : "";
            vm.dataForm.lon = poi.lng ? poi.lng.toString() : "";
          }
        });
        vm.amap.center = [lngSum, latSum];
        let LatLng = latSum + ',' + lngSum
        vm.$emit("updateLocationMap", vm.dataForm);
      }
    },
    // 提交方法
    sure() {
      const vm = this;
      console.log('地址信息', vm.dataForm)
      vm.initSearchValue(vm.dataForm.orgAddr)
      vm.$emit("updateLocationMap", vm.dataForm);
    },
  },
};
</script>
<style lang="less" scoped>
.amap-box {
  height: 420px;
  // height: calc(100vh - 45px);
}

.el-vue-search-box-container {
  // top: 45px;
  width: 100% !important;
}

.search-box {
  position: absolute;
  z-index: 5;
  width: 70%;
  left: 13%;
  top: 10px;
  height: 30px;
}

.search-box .el-input {
  float: left;
  width: 100%;
  height: 100%;
  box-sizing: border-box;
  border-radius: 0 7px 7px 0;
  outline: none;
  position: relative;
}

.search-box .el-button {
  position: absolute;
  right: 0;
  top: 1px;
  width: 20%;
  background: #38a28a;
  border-radius: 0 7px 7px 0;
  border: none;
  color: #fff;
  outline: none;
}

.tip-box {
  text-align: center;
  width: 100%;
  position: absolute;
  top: 35px;
  padding: 10px 0;
  background-color: #fff;
  opacity: 0.8;
}
</style>
